//Import Composant MUI
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

//Import fonction router
import { useLocation } from "react-router";

export default function PagePaper({ children, name }) {
	const location = useLocation().pathname.split("/").slice(-1);

	return (
		<Stack
			component={Paper}
			variant="outlined"
			p={1}
			spacing={1}
		>
			<Typography
				variant={"h3"}
				sx={(theme) => ({
					textTransform: "capitalize",
					[theme.breakpoints.down("sm")]: {
						fontSize: "1.8rem",
					},
				})}
			>
				{name ? name : location.toString().replaceAll("_", " ")}
				<Divider flexItem />
			</Typography>

			{children}
		</Stack>
	);
}
